import { useCallback, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { getMapLink } from '@/utils/system';
import { useDispatch, useSelector } from 'react-redux';
import {
  actionsTracking,
  trackingSelector,
} from '@/reducers/tracking/tracking.slice';
import { Tracking } from '@/reducers/tracking/types';
import styles from '../newStepper.module.scss';
import { DescriptionProps } from '../newStepper.types';

const Description = ({ step, deliveryPromiseTime }: DescriptionProps) => {
  const { pointInfo } = useSelector(trackingSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (step.pointId) {
      dispatch(actionsTracking.getPointInfoRequest(step.pointId));
    }
  }, [dispatch, step]);

  const addTrackingText = useCallback(
    (trackingStep: Tracking, date: string) => {
      const promiseTime = '{{fecha_entrega}}';
      let text = trackingStep.description;

      if (trackingStep.description?.includes(promiseTime)) {
        text = trackingStep.description.replace(promiseTime, date);
      }

      if (pointInfo) {
        const url = getMapLink(null, pointInfo);
        const link = `<a href="${url}" target="_blank" rel="noreferrer">${pointInfo.name}</a>`;
        text = trackingStep.description.replace(pointInfo.name, link);
      }

      if (trackingStep.alert === 'INFO') {
        text = `⚠️ ${text}`;
      }

      return text;
    },
    [pointInfo],
  );

  return (
    <>
      <p
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(
            addTrackingText(step, deliveryPromiseTime),
            {
              ADD_ATTR: ['target'],
            },
          ),
        }}
        className={styles.description}
      />
    </>
  );
};

export default Description;
